<template>
    <div class="of-content-1">
        <description class="item1" :view="ofContent1.description"/>
        <social-media class="item2" :view="ofContent1.socialMedia"/>
        <tutorial class="item3" :view="ofContent1.tutorial"/>
    </div>
</template>


<script>
    import SocialMedia from "./social-media.vue"
    import Tutorial from "./tutorial.vue"
    import Description from "./description.vue"

    export default {
        name: "of-content-1",
        props: ["view"],
        components: {
            "social-media": SocialMedia,
            'tutorial': Tutorial,
            'description': Description
        },
        data() {
            return {
                description: {
                    title: "Dashboard Funnel Club",
                    text: 'Auctor aliquam ut quam nibh consequat sociosqu senectus condimentum feugiat. Nunc facilisis auctor donec etiam mauris laoreet. Nunc sollicitudin nostra vestibulum. Quisque sodales purus amet nostra mattis eget placerat vehicula vulputate. Interdum leo inceptos lectus imperdiet vehicula ultrices sit.'
                },
                socialMedia: {
                    mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-1/ic-social-media-card.svg',
                    title: 'Join Community',
                    text: 'Auctor aliquam ut quam nibh consequat sociosqu senectus condimentum feugiat.',
                    'url_socials': { /* nao colocar no translation na view php, vem de outro lugar */
                        facebook: {
                            title: 'titulo facebook',
                            text: 'texto facebook',
                            link: 'https://www.facebook.com/'
                        },
                        instagram: {
                            title: 'titulo instagram',
                            text: 'texto instagram',
                            link: 'https://www.instagram.com/'
                        },
                        twitter: {
                            title: 'titulo twitter',
                            text: 'texto twitter',
                            link: 'https://twitter.com/'
                        },
                        youtube: {
                            title: 'titulo youtube',
                            text: 'texto youtube',
                            link: 'https://www.youtube.com/'
                        }                     
                    },
                    socialMediaSvg: {
                        facebook: '/internacional/public/office4/img/onboarding-funnel/content-1/ic-facebook.svg',
                        instagram: '/internacional/public/office4/img/onboarding-funnel/content-1/ic-instagram.svg',
                        twitter: '/internacional/public/office4/img/onboarding-funnel/content-1/ic-twitter.svg',
                        youtube: '/internacional/public/office4/img/onboarding-funnel/content-1/ic-youtube.svg'                 
                    }
                },
                tutorial: {
                    mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-1/ic-youtube-tutorial.svg',
                    title: 'Tutorial',
                    text: 'Auctor aliquam ut quam nibh consequat sociosqu senectus condimentum feugiat.',
                    button: {
                        text: "Learn more",
                        link: "#"
                    }
                }
            }
        },
        computed: {
            ofContent1: function () {
                return (this.view !== undefined && this.view !== null) ? this.view : this.$data
            }
        },
        created() {
        },
        mounted() {
        }
    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../../../../../scss/office";
    
    .of-content-1{
        font: inherit;
        line-height: inherit;

        display: grid;
        grid-template-columns: repeat(10, 1fr);
        grid-template-rows: repeat(2, auto);
        column-gap: 2.6229508%; /* 32px */
        row-gap: 3.2em; /* 32px */
        justify-items: stretch;
        align-items: stretch;
        justify-content: stretch;
        align-content: stretch;

        margin-bottom: 3.8em!important;/*38px*/

        .item1{
            grid-row-start: 1;
            grid-row-end: 2;
            grid-column-start: 1;
            grid-column-end: 11;
        }
        .item2{
            grid-row-start: 2;
            grid-row-end: 3;
            grid-column-start: 1;
            grid-column-end: 7;
        }
        .item3{
            grid-row-start: 2;
            grid-row-end: 3;
            grid-column-start: 7;
            grid-column-end: 11;
        }

    }

    @media (max-width: 768px) { /* smartphones e tablets */
        .of-content-1{
            grid-template-columns: repeat(10, 1fr);
            grid-template-rows: repeat(2, auto);
            column-gap: 0;
            row-gap: 3.2em; /* 32px */

            .item1,
            .item2,
            .item3{
                grid-column: span 10;
            }

            .item1{
                grid-row-start: 1;
                grid-row-end: 2;
            }
            .item2{
                grid-row-start: 2;
                grid-row-end: 3;
            }
            .item3{
                grid-row-start: 3;
                grid-row-end: 4;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/dashboard/onboardingFunnel/content-1/index.vue